import { useContext, type Dispatch } from 'react';

import type { CustomizationAction } from './actions';
import { CustomizationDispatchContext } from './TemplateCustomizationProvider';

export function useCustomizationDispatch(): Dispatch<CustomizationAction> {
  const dispatch = useContext(CustomizationDispatchContext);

  if (!dispatch) {
    throw new Error(
      'useCustomizationDispatch must be used within TemplateCustomizationProvider'
    );
  }

  return dispatch;
}
